import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AppCommonModule } from '@app/shared/common/app-common.module';
import {
    LucideAngularModule, Clock, ChevronDown, ChevronRight, ChevronLeft,
    Play, Pause, Square, Plus, Search, Ellipsis, Pencil, Trash2, Check, X, Download, Funnel, Calendar, FileSpreadsheet, User
} from 'lucide-angular';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { AgGridModule } from 'ag-grid-angular';

import { SidebarTimerIndicatorComponent } from './components/sidebar-timer-indicator/sidebar-timer-indicator.component';
import { TaskTimeSectionComponent } from './components/task-time-section/task-time-section.component';
import { TaskTimeOverlayComponent } from './components/task-time-overlay/task-time-overlay.component';
import { ProjectTimeTabComponent } from './components/project-time-tab/project-time-tab.component';

@NgModule({
    declarations: [
        SidebarTimerIndicatorComponent,
        TaskTimeSectionComponent,
        TaskTimeOverlayComponent,
        ProjectTimeTabComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        AppCommonModule,
        LucideAngularModule.pick({ Clock, ChevronDown, ChevronRight, ChevronLeft, Play, Pause, Square, Plus, Search, Ellipsis, Pencil, Trash2, Check, X, Download, Funnel, Calendar, FileSpreadsheet, User }),
        BsDropdownModule.forRoot(),
        BsDatepickerModule.forRoot(),
        AgGridModule
    ],
    providers: [],
    exports: [
        SidebarTimerIndicatorComponent,
        TaskTimeSectionComponent,
        TaskTimeOverlayComponent,
        ProjectTimeTabComponent
    ]
})
export class TimeTrackingModule {}
